var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-pagination", {
    attrs: {
      "current-page": _vm.current,
      "page-size": _vm.size,
      total: _vm.total,
      "pager-count": 5,
      "page-sizes": [100, 200, 300, 400],
      layout: "total, sizes, prev, pager, next, jumper",
      background: ""
    },
    on: {
      "size-change": _vm.onSizeChange,
      "current-change": _vm.onCurrentChange
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }